import React from "react";
import AuthLayout from "../../../layout/AuthLayout";
import { CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { CustomInput } from "../../../components/Common/CustomInputs";
import { EmailOutlined, LoginOutlined } from "@mui/icons-material";
import { CustomBtn } from "../../../components/Common/CustomBtn";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { useForgotPassword } from "./ForgotPassword.hooks";
import {
  PAGE_TITLE,
  PAGE_SUBTITLE,
  EMAIL_PLACEHOLDER,
  SUBMIT_BUTTON_TEXT,
  SUCCESS_MESSAGE,
} from "./ForgotPassword.constants";
import {
  ContentBox,
  Title,
  Subtitle,
  FormBox,
  StyledBackdrop,
} from "./ForgotPassword.styles";

const ForgotPassword = () => {
  const theme = useTheme();
  const mediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const {
    email,
    setEmail,
    loading,
    success,
    errorState,
    handleSubmit,
    closeSuccess,
    closeError,
  } = useForgotPassword();

  return (
    <AuthLayout>
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={closeSuccess}
        text={SUCCESS_MESSAGE}
      />

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={closeError}
        errorMsg={errorState.message}
      />

      <ContentBox>
        <Title>{PAGE_TITLE}</Title>
        <Subtitle>{PAGE_SUBTITLE}</Subtitle>

        <FormBox>
          <CustomInput
            placeholder={EMAIL_PLACEHOLDER}
            value={email}
            setValue={setEmail}
            Icon={EmailOutlined}
            width="100%"
            color={theme.palette.text.primary}
          />
        </FormBox>

        <CustomBtn
          text={SUBMIT_BUTTON_TEXT}
          Icon={LoginOutlined}
          width={mediumScreen ? "60%" : "40%"}
          onClick={handleSubmit}
        />
      </ContentBox>

      <StyledBackdrop open={loading}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
    </AuthLayout>
  );
};

export default ForgotPassword;
